import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Root } from './SmartTools.css';
import ListAlt from '@material-ui/icons/ListAlt';
import PageTitle from '../Layout/components/PageTitle';
import { Paper, Table, TableHead, TableRow, TableCell, TableBody, Button, InputBase, Dialog, Drawer, TableFooter, TablePagination, Tabs, Tab } from '@material-ui/core';
import { BASE_URL } from '../../store/config';
import instance from '../../request/http';
import { roleStr, roleName, roleInfo } from '../../common/common';
import { timeFormat, toMoney } from '../../common/utils';
import AlertDialog from '../Layout/components/AlertDialog'

class SmartTools extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            tabIndex: 0
        }
        this.handleItem = this.handleItem.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }
    render() {
        const {
            tabIndex
        } = this.state;
        const showTabPanel = () => {
            if (tabIndex === 0) {
                return <Paper className="tableWapper h">
                    <div className="itemWapper c" onClick={e => this.handleItem(e, "e")}>
                        <div className="estateImg c"></div>
                        <div className="text">Estate-Planning Files Generator</div>
                    </div>
                </Paper>
            }else if(tabIndex === 3){
                return <Paper className="tableWapper h">
                    <div className="itemWapper c" onClick={e => this.handleItem(e, "t")}>
                        <div className = "estateImg c"></div>
                        <div className = "text">Trademark Image Tool</div>
                    </div>                   
                </Paper>
            } 
            else {
                return <Paper className="tableWapper h"></Paper>
            }
        }
        return (
            <Root>
                <div className="head h h-t">
                    <PageTitle title="All Cases" subtitle="MANAGEMENT"></PageTitle>
                </div>
                <Tabs
                    value={tabIndex}
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={this.handleChange}
                    TabIndicatorProps={{ style: { display: "none" } }}
                >
                    <Tab className={tabIndex === 0 ? "tabSelect" : "tab"} label="Estate-Planning " />
                    <Tab className={tabIndex === 1 ? "tabSelect" : "tab"} label="Immigration" />
                    <Tab className={tabIndex === 2 ? "tabSelect" : "tab"} label="Business" />
                    <Tab className={tabIndex === 3 ? "tabSelect" : "tab"} label="IP" />
                    <Tab className={tabIndex === 4 ? "tabSelect" : "tab"} label="Real Estate" />
                </Tabs>
                {showTabPanel()}
            </Root>
        );
    }
    componentDidMount() {
    }
    handleItem(e, name) {
        switch (name) {
            case "e":
                this.props.history.push({ pathname: '/main/toolestate' });
                break;
            case "eu":
                this.props.history.push({ pathname: '/main/toolestateuser'});
                break;
            case "t":
                this.props.history.push({ pathname: '/main/tooltrademark'});
                break;
            default:
                break;
        }
    }
    handleChange(e, newValue) {
        let tabIndex = newValue;
        this.setState(() => ({
            tabIndex
        }))
    }
}

export default withRouter(SmartTools);